// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"110e154b","230":"d3893603","283":"3b6d5537","397":"cdb7cff5","399":"13efb94e","453":"821fd3de","713":"655a665f","773":"d110be5f","780":"72ac5c23","831":"8a1de453","842":"76da348b"}[chunkId] + ".chunk.js";
};